import { selectCallConfig, selectParticipants, selectRoomId } from 'state/selectors';

/**
 * Извлекает тип звонка из roomId/roomName
 * Формат roomName: uuid:userId:groupId:TYPE:stage:...
 * @returns 'P2P' | 'GROUP' | null
 */
const getCallTypeFromRoomId = (): 'P2P' | 'GROUP' | null => {
    const roomId = selectRoomId();
    if (!roomId) return null;

    // формат: uuid:userId:groupId:TYPE:stage:...
    const parts = roomId.split(':');
    if (parts.length < 4) return null;

    const callType = parts[3];
    if (callType === 'P2P' || callType === 'GROUP') return callType;

    return null;
};

/**
 * Определяет, является ли звонок P2P
 * Приоритет определения:
 * 1. callConfig (для embedded режима)
 * 2. roomId/roomName (из URL)
 * 3. fallback по количеству участников
 * @returns true если звонок P2P, false если групповой
 */
export const isP2pCall = (): boolean => {
    const callConfig = selectCallConfig();
    const callTypeFromRoomId = getCallTypeFromRoomId();

    // callConfig (для embedded режима)
    if (callConfig?.isP2pCall !== undefined) return callConfig.isP2pCall;

    return callTypeFromRoomId === 'P2P';
};

/**
 * Звонок из группового чата или P2P, в который добавили 3+ участника.
 * Для классического P2P (2 человека) настройки звонка и waiting room policy не применяются.
 */
export const isGroupMeetCall = (): boolean => {
    const callConfig = selectCallConfig();
    if (callConfig?.isGroupCall) return true;
    if (!isP2pCall()) return true;

    return selectParticipants().length > 2;
};

/** Настройки звонка (политика входа, модерация) */
export const isCanUseCallSettings = (): boolean => isGroupMeetCall();
